export default __webpack_public_path__ + "static/UniversLTStd-5d6f7d9f348515d015214f2da07abb32.ttf";